class WDNSlide extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute("data-id");
    this.triggers = this.getTriggersById(this.id);
    this.closers = this.getClosersById(this.id);
    this.isVisible = this.getAttribute("data-visible") === "";
    this.scroll_container = this.querySelector("[data-scroll-container]");
    this.init();
  }

  setState(state) {
    this.isVisible = state;
    if (state) {
      this.setAttribute("data-visible", "");
    } else {
      this.removeAttribute("data-visible");
    }
  }

  adjustScrollContainer(state) {
    if (!this.scroll_container || !state) return;
    this.scroll_container.scroll(0, 0); // reset scroll position to top
  }

  toggle() {
    this.adjustScrollContainer(!this.isVisible);
    this.setState(!this.isVisible);
  }
  openOverlay(overlay_id) {
    document.body.dispatchEvent(
      new CustomEvent("overlay:open", {
        detail: {
          id: overlay_id,
        },
      })
    );
  }

  triggerOnClick(e) {
    var overlay_id = e.currentTarget.getAttribute("data-overlay-id");
    this.toggle();
    if (!overlay_id || overlay_id == "") return;
    // in order to hide transition between slides
    setTimeout(
      function () {
        this.openOverlay(overlay_id);
      }.bind(this),
      100
    );
  }

  getTriggersById(id) {
    return document.querySelectorAll("[data-slide-to='" + id + "']");
  }

  getClosersById(id) {
    return document.querySelectorAll("[data-slide-back='" + id + "']");
  }

  closerOnClick() {
    this.setState(false);
  }

  onDrawerClose(e) {
    this.isVisible ? this.setState(false) : "";
  }

  bindTriggers() {
    this.triggers.forEach(function (trigger) {
      trigger.addEventListener("click", this.triggerOnClick.bind(this));
    }, this);
  }

  bindClosers() {
    this.closers.forEach(function (closer) {
      closer.addEventListener("click", this.closerOnClick.bind(this));
    }, this);
  }

  listenForDrawerClose() {
    document.body.addEventListener("filter_modal:close", this.onDrawerClose.bind(this));
  }

  bind() {
    this.bindTriggers();
    this.bindClosers();
    this.listenForDrawerClose();
  }
  init() {
    this.bind();
  }
}

customElements.define("wdn-slide", WDNSlide);
